export const promoBannersByIdTranslationKeys = {
  promoBannerByIdDescription: 'promo.banner-by-id-description',
}
